import { fetchClientGraphQL } from '~/hooks/graphql.js';
import { getMinimalProductNode, getVariationProductNode } from '~/hooks/queries/use-product-data-query.js';

const freePickProductFields = `
  productId
  name
  uri
  freePickNormalPrice
  productVendor { name slug }
  defaultCurrency { code price regularPrice salePrice priceExTax regularPriceExTax salePriceExTax }
  featuredImage { node { sourceUrl(size: MEDIUM) } }
  ... on SimpleProduct {
    price(format: FORMATTED)
    productSpecs {
      node {
        productSoundcloudCode
        soundcloudShortcode
        audioDemos { url peaksUrl duration format title source scTrackId lufs truePeak }
      }
    }
  }
  ... on VariableProduct {
    price(format: FORMATTED)
    productSpecs {
      node {
        productSoundcloudCode
        soundcloudShortcode
        audioDemos { url peaksUrl duration format title source scTrackId lufs truePeak }
      }
    }
  }
`;

const getCartItemNode = `
  cartItem {
    key
    quantity
    isFreePick
    relativeSingleUnitPrice
    subtotal
    subtotalTax
    tax
    total
    product {
      node {
        productId
        productVendor {
          name
          slug
        }
      }
    }
    subscriptionItemDetails {
      duration
      signUpFee
      subscriptionRenewalDate
      total
      name
    }
  }
`;

const getCartNode = `
  cart {
    contentsTax
    contentsTotal
    discountApplied
    discountTax
    discountTotal
    displayPricesIncludeTax
    feeTax
    feeTotal
    isEmpty
    subtotal
    subtotalTax
    total
    totalRaw: total(format: RAW)
    totalTax
    requiresPayment
    systemNotices {
      message
      noticeType
    }
    contents(first: 100) {
      productCount
      itemCount
      nodes {
        ${ getMinimalProductNode }
        ${ getVariationProductNode }
        quantity
        isFreePick
        relativeSingleUnitPrice
        subtotal
        total
        key
        subscriptionItemDetails {
          duration
          signUpFee
          subscriptionRenewalDate
          total
          name
        }
      }
    }
    appliedCoupons {
      code
      discountAmount
    }
    bonusContent {
      otherMessages
    }
    freePick {
      enabled
      unavailableReason
      currency
      qualifyingAmount
      highestUnlockedTier
      availableTier
      seatCount
      amountToNextTier
      thresholds
      selectedProductId
      selectedTier
      selectedProduct { ${freePickProductFields} }
      candidates(first: 24, offset: 0) {
        nodes {
          ${freePickProductFields}
        }
        hasMore
        nextOffset
      }
    }
  }
`;

const getCartDataQuery = `query Cart { ${getCartNode} }`;

const getFreePickCandidatesQuery = `
  query FreePickCandidates($first: Int!, $offset: Int!) {
    cart {
      freePick {
        candidates(first: $first, offset: $offset) {
          nodes {
            ${freePickProductFields}
          }
          hasMore
          nextOffset
        }
      }
    }
  }
`;

const fetchCartData = () => {
  return fetchClientGraphQL(getCartDataQuery, {}, (data) => {
    return data
  });
};

const fetchFreePickCandidates = (first, offset) => {
  return fetchClientGraphQL(
    getFreePickCandidatesQuery,
    { first, offset },
    (data) => data?.data?.cart?.freePick?.candidates,
  );
};

export {
  getCartNode,
  getCartItemNode,
  getCartDataQuery,
  fetchCartData,
  fetchFreePickCandidates,
}
